// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_VJn","cls2":"UpsellModalRedesign-cls2_SkB UpsellModalRedesign-cls1_VJn"};